<!-- Prescription Item -->
<div class="card card-table">
    <div class="card-body">
        


        <div class="prescription-items-container">
            <div class="table-responsive">
                <table class="table table-hover table-center">
                    <thead>
                        <tr>
                      
                            <th>Médicament
                                <button class="openDialoge" [title]="'Ajouter Medics'" (click)="openDrawer()">
                                    <i class="fas fa-capsules"></i>    
                                </button>
                            </th>
                            <th>Posologie</th>
                            <th>Durée</th>
                            <th class="text-center">Unité</th>
                            <th>Note</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let medicPrescriptionItem of medicPrescriptionItems; let i = index"
                            [ngStyle]="{'border':!validatePrescriptionItem(medicPrescriptionItem).isValid && submitted ? '1px solid red' : 'None'}">
                            
                      

                            <td style="width: 250px;">
                                <app-medic-select-dropdown 
                                    [(value)]="medicPrescriptionItem.medic" 
                                    (valueChange)="onEditPrescriptionItem(i)" 
                                    [placeHolder]="'Chercher Médicament'">
                                </app-medic-select-dropdown>
                            </td>

                            <td style="max-width: 150px;">
                                <input class="form-control" 
                                       type="text" 
                                       (ngModelChange)="change()"
                                       [(ngModel)]="medicPrescriptionItem.posology">
                                <div *ngIf="validatePrescriptionItem(medicPrescriptionItem).controlsValidation['posology'] == 'required' && submitted">
                                    <span style="color: red">Posologie est obligatoire</span>
                                </div>
                            </td>

                            <td style="max-width: 90px;">
                                <input class="form-control" 
                                       type="number" 
                                       min="1" 
                                       (ngModelChange)="change()" 
                                       [(ngModel)]="medicPrescriptionItem.duration">
                                <div *ngIf="validatePrescriptionItem(medicPrescriptionItem).controlsValidation.duration && submitted">
                                    <span *ngIf="validatePrescriptionItem(medicPrescriptionItem).controlsValidation.duration == 'required'" style="color: red">
                                        Durée est obligatoire
                                    </span>
                                    <span *ngIf="validatePrescriptionItem(medicPrescriptionItem).controlsValidation.duration == 'number'" style="color: red">
                                        Durée doit être numérique
                                    </span>
                                    <span *ngIf="validatePrescriptionItem(medicPrescriptionItem).controlsValidation.duration == 'min'" style="color: red">
                                        Durée doit être > 0
                                    </span>
                                </div>
                            </td>

                            <td>
                                <div class="d-flex gap-2 justify-content-start">
                                    <div>
                                        <input type="radio" 
                                               [(ngModel)]="medicPrescriptionItem.unit" 
                                               (ngModelChange)="change()"  
                                               [name]="'unit' + i" 
                                               [value]="0" 
                                               class="mx-1" />
                                        <label>J</label>
                                    </div>
                                    <div>
                                        <input type="radio"  
                                               [(ngModel)]="medicPrescriptionItem.unit" 
                                               (ngModelChange)="change()"
                                               [name]="'unit' + i" 
                                               [value]="1" 
                                               class="mx-1" />
                                        <label>S</label>
                                    </div>
                                    <div>
                                        <input type="radio"  
                                               [(ngModel)]="medicPrescriptionItem.unit" 
                                               (ngModelChange)="change()"
                                               [name]="'unit' + i" 
                                               [value]="2" 
                                               class="mx-1" />
                                        <label>M</label>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <textarea class="form-control" 
                                          style="height: 45px;" 
                                          [(ngModel)]="medicPrescriptionItem.note" 
                                          (ngModelChange)="change()"></textarea>
                            </td>

                            <td>
                                <a href="javascript:void(0)" 
                                   class="btn bg-danger-light trash" 
                                   (click)="deletePrescriptionItem(i)">
                                    <i class="feather-trash-2"></i>
                                </a>
                            </td>
                        </tr>
                        
                        <tr *ngIf="medicPrescriptionItems.length === 0">
                            <td colspan="8" class="text-center text-muted">
                                Aucun élément à afficher
                            </td>
                        </tr>
                        
                        <tr>
                            <td colspan="8">
                                <div class="add-more-item text-center">
                                    <a href="javascript:void(0);" (click)="addPrescriptionItem()">
                                        <i class="feather-plus-circle"></i> Ajouter
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</div>

<!-- Modal pour ajouter médicament -->
<app-modal [title]="'Ajouter Nouveau Médicament'" #dialog>
    <app-medic-form #medicForm (ngModelChange)="change()"></app-medic-form>
    <button class="btn btn-outline-info mb-3 mt-3" (click)="onAddMedic()">Ajouter Médicament</button>
</app-modal>

<!-- Drawer pour sélectionner médicaments -->
<app-drawer [active]="drawerActive" [title]="'Ajouter Medics'">
    <div body style="height: 80%;">
        <app-medic-select-drawer  
            [(values)]="medics"
            (valuesChange)="change()" 
            (closed)="closed()" 
            [(medicsSelected)]="medicsFilter">
        </app-medic-select-drawer>
    </div>
</app-drawer>